import { Component, Input } from '@angular/core';
import { DsChart } from '../../classes/ds-chart.class';

@Component({
  selector: 'ds-generic-chart',
  templateUrl: './ds-generic-chart.component.html',
  styleUrls: ['./ds-generic-chart.component.scss'],
})
/**
 * Simply display chart given in parameter
 */
export class DsGenericChartComponent {
  /**
   *
   */
  @Input() chart: DsChart;

  /**
   * Message displayed instead of the chart if there is not data.
   * Only displayed if the chart object is defined, but there is no data in chart.datasets
   */
  @Input() noDataMessage = 'dsCharts.noData';
}
